import React, { useContext, useEffect, useState } from 'react';
import { Spinner, P } from '@sorted/sorted-ui';
import RemoteLoader from '../../components/RemoteLoader';
import runtimeConfig from '../../config';
import MicroFrontendContext from '../../context/MicroFrontendContext';
import getWebpackManifest from '../../services/getWebpackManifest';
import ErrorPage from '../ErrorPage';

const ShipmentsPage = () => {
	const microFrontendProps = useContext(MicroFrontendContext);

	const [resolvedUrl, setResolvedUrl] = useState('');
	const [error, setError] = useState(null);

	useEffect(() => {
		getWebpackManifest(runtimeConfig.remotes.shipments)
			.then(response => {
				setResolvedUrl(response['shipments.js']);
			})
			.catch(e => {
				setError(e);
			});
	}, []);

	if (error) {
		return (
			<ErrorPage>
				<P>Failed to load or parse app manifest for shipments.</P>
			</ErrorPage>
		);
	}

	if (!resolvedUrl) {
		return <Spinner />;
	}

	return (
		<RemoteLoader
			url={resolvedUrl}
			scope="shipments"
			module="./ShipmentsRemote"
			componentProps={microFrontendProps}
		/>
	);
};

export default ShipmentsPage;
